import s from './AllSpecialists.module.scss';
import {ReactComponent as Star} from 'images/new-icons/rating-start.svg';
import Button from 'components/shared/Button';
import useGetServicesTeamsByServiceIdConvert from 'sdk/hooks/booking/useGetServicesTeamsByServiceIdConvert';
import useGetSpecialistsBySalonId from 'sdk/hooks/salon/useGetSpecialistsBySalonId';
import {useNavigate} from 'react-router-dom';
import useIsAuth from 'sdk/hooks/useIsAuth';
import {useTranslation} from 'react-i18next';

import SpecialistRating from 'components/shared/SpecialistRating';
import useGetSpecialistRating from 'sdk/hooks/salon/useGetSpecialistRating';

interface BaseSpecialist {
    id: string;
    full_name: string;
    avatar: string;
}

const SpecialistRatingContainer = ({ teamId }: { teamId: string }) => {
    const { data } = useGetSpecialistRating(teamId);
    return <SpecialistRating rating={data?.average || 0} count={data?.count} />;
};

const AllSpecialistsList = ({serviceId, salonId}: { serviceId?: string; salonId?: string }) => {
    const navigate = useNavigate();
    const {data: isAuthData} = useIsAuth();
    const {data: specialistsByService} = useGetServicesTeamsByServiceIdConvert(serviceId, salonId);
    const {data: specialistsBySalon} = useGetSpecialistsBySalonId(salonId);
    const {t} = useTranslation() as any
    const specialists = serviceId && serviceId !== 'all' ? specialistsByService : specialistsBySalon;

    const getSpecialistData = (specialist: any): BaseSpecialist => {
        if ('teams' in specialist) {
            return {
                id: specialist.teams.id,
                full_name: specialist.teams.full_name,
                avatar: specialist.teams.avatar,
            };
        }
        return {
            id: specialist.id,
            full_name: specialist.full_name,
            avatar: specialist.avatar,
        };
    };

    const specName = (name: string, specialistId: string) => {
        return (
            <div className={s.spec_container}>
                <div className={s.spec}>
                    <div className={s.spec_name}>{name}</div>
                    <div className={s.spec_rating}>
                        <SpecialistRatingContainer teamId={specialistId} />
                    </div>
                </div>
                <div className={s.action}>
                    <Button
                        className={s.action_button}
                        darkGreen
                        onClick={() => {
                            if (isAuthData?.isAuth) {
                                navigate(`/appointment-booking-spec/salon/${salonId}/specialist/${specialistId}`);
                            } else {
                                navigate('/sign-up');
                            }
                        }}
                    >
                        {t('Book')}
                    </Button>
                </div>
            </div>
        );
    };

    return (
        <div className={s.all_specialists_list}>
            {specialists?.map(specialist => {
                const data = getSpecialistData(specialist);
                return (
                    <div key={data.id} className={s.card}>
                        <img className={s.card_image} src={data.avatar} alt={data.full_name}/>
                        {specName(
                            data.full_name
                                .split(' ')
                                .map((name: string, index: number, array: string[]) =>
                                    index === array.length - 1 ? `${name[0]}.` : name,
                                )
                                .join(' '),
                            data.id,
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default AllSpecialistsList;
